import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService, ToastrNotificationService } from '@lbmx/phoenix-lib-utils';
import { BaseHttpService } from '@lbmx/root-services';
import { SearchContainerLoaderService } from '@lbmx/search-container';
import { Request as BuilderRequest, } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng-lts';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { apiUrls } from 'src/app/features/automations-module/url-config';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Component({
  selector: 'app-sales-data-preference',
  templateUrl: './sales-data-preference.component.html',
  styleUrls: ['./sales-data-preference.component.scss'],
  providers: [SearchContainerLoaderService, ConfirmationService],
})
export class SalesDataPreferenceComponent {
  constructor(
    private translocoService: TranslocoService,
    private confirmationService: ConfirmationService,
    private toast: ToastrNotificationService,
    private spinner: SpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private configPrv: ConfigProvider,
    private http: BaseHttpService,
    private searchContainerLoaderService: SearchContainerLoaderService
  ) {
    http.baseUrl = this.baseUrl;
  }

  // public selectedRecord: any = {};
  public selectedRecord: any[];
  public showAddOptionDialog = false;
  public showEditOptionDialog = false;

  // search container loader states
  public selections: any[];
  public searchContainerName = 'supplierSearch';
  public showGenerateFileDialog = false;

  public i18nSearchField = 'ANALYTICS.SEARCH_SUPPLIER_LOCATION_NAME';
  public params: { [key: string]: any } = {};
  public baseUrl = `${this.configPrv.AppSetting?.uriAnalytics?.queryEndpoint}` + '/AdminCentre/sales-data-preference';

  public toolbarActionsDispatcher = {
    new: (selection: any[]) => {
      this.showAddOptionDialog = true;
    },

    edit: (selection: any[]) => {
      this.selectedRecord = [...selection];
      this.showEditOptionDialog = true;
    },

    delete: (selection: any[]) => {
      this.selectedRecord = [...selection];

      this.confirmationService.confirm({
        message: this.translocoService.translate(
          'ANALYTICS.DELETE_DATA_PREFERENCE_MESSAGE'
        ),
        header: this.translocoService.translate(
          'ANALYTICS.DELETE_DATA_PREFERENCE'
        ),
        acceptLabel: this.translocoService.translate('ACTIONS.YES'),
        rejectLabel: this.translocoService.translate('ACTIONS.NO'),

        accept: () => {
          this.spinner.on();
          const selectedKeys = [...selection].map(
            ({ dataPreferenceKey, ..._ }) => dataPreferenceKey
          );
          this.http
            .fetch({
              endpoint: '/delete-option',
              httpMethod: 'POST',
              body: {
                DataPreferenceKey: selectedKeys,
              },
            })
            .pipe(
              tap(() => {
                this.toast.successNotify(
                  this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
                );

                this.searchContainerLoaderService.refreshSearch();
              }),
              catchError(() =>
                of(
                  this.toast.errorNotify(
                    this.translocoService.translate('MESSAGES.GENERIC_ERROR')
                  )
                )
              ),
              finalize(() => this.spinner.off())
            )
            .subscribe();
        },
        reject: () => {
          /* empty */
        },
      });
    },
   };

  public columnActions = {};

  public closeAddOptionDialog() {
    this.showAddOptionDialog = false;
  }

  public updateAddOption() {
    this.searchContainerLoaderService.refreshSearch();
  }

  public closeEditOptionDialog() {
    this.showEditOptionDialog = false;
  }

  public updateEditOption() {
    this.searchContainerLoaderService.refreshSearch();
  }
}
